import { render, staticRenderFns } from "./AfterDisposedItemModal.vue?vue&type=template&id=d55df63a&"
import script from "./AfterDisposedItemModal.vue?vue&type=script&lang=js&"
export * from "./AfterDisposedItemModal.vue?vue&type=script&lang=js&"
import style0 from "./AfterDisposedItemModal.vue?vue&type=style&index=0&id=d55df63a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports